export const simOuNao = [
  { label: "Sim", value: 1 },
  { label: "Não", value: 0 },
];

export const trueOuFalse = [
  { label: "Sim", value: true },
  { label: "Não", value: false },
];

export const voltagem = [
    { label: "110v", value: 1 },
    { label: "220v", value: 2 },
];

export const arredondamento = [
  { label: "P/CIMA", value: "P/CIMA" },
  { label: "SIM", value: "SIM" },
  { label: "NÃO", value: "NAO" },
];

export const status = [
  { label: "Ativo", value: 1 },
  { label: "Descontinuado", value: 2 },
  { label: "Arquivo Morto", value: 5 },
  { label: "Em homologação", value: 6 },
  { label: "Novo Portfólio", value: 7 },
];
export const unidade = [
  { label: "KG", value: 4 },
  { label: "MT", value: 3 },
];
export const tipoKit = [
  { label: "Engenharia", value: 2 },
  { label: "Ferragem", value: 1 },
];

export const situacao = [
  { label: "Em Edição", value: 1 },
  { label: "Em Homologação", value: 2 },
  { label: "Disponível para Mercado", value: 3 },
  { label: "Indisponível para Mercado", value: 4 },
  { label: "Disponível CEM DELPHI", value: 5 },
];

export const tipoMaterial = [
  { label: "Componentes", value: "COMPONENTE" },
  { label: "Perfis", value: "PERFIL" },
  { label: "Vidros", value: "VIDRO" },
  { label: "Superficies", value: "SUPERFICIE" },
  { label: "Kits", value: "KIT" },
];
